import { isRecord } from '@sweetistics/contracts/utils/type-guards';

/**
 * Shared error helpers for tweet data workflows.
 */

/**
 * Normalize errors from tRPC batch tweet loads so callers can surface actionable
 * feedback (e.g., prompt for re-authentication) instead of a generic message.
 */
export function translateBatchLoadError(error: unknown): Error {
  const httpStatus = readHttpStatus(error);

  if (httpStatus === 401) {
    return new Error('Your session expired. Sign in again to view this tweet.');
  }

  if (error instanceof Error) {
    return error;
  }

  return new Error('Failed to load tweet preview.');
}

const readHttpStatus = (value: unknown): number | undefined => {
  if (!isRecord(value)) {
    return;
  }
  const data = (value as { data?: unknown }).data;
  if (!isRecord(data)) {
    return;
  }
  const status = (data as { httpStatus?: unknown }).httpStatus;
  return typeof status === 'number' ? status : undefined;
};
